import React from "react";
import { Container, Typography, Paper, Card, Box } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";
import PageIntro from "../components/pageintro";
import SplitDescription from "../components/splitdescription";
import ServicesGridCards from "../components/servicesgrid";
import TransformComponent from "../components/transformcomp";
import GridCards from "../components/oddservicegrids";

const offeringdata = [
    {
      src: "/assets/AdvancedAI/ComputerVision/tracking.png",
      alt: "Object Detection and Tracking",
      width: "60%",
      paddingTop: "2%",
      text: "Object detection &<br />Tracking",
      description:
        "With our 7+ years of experience, we assist your business by boosting material by categorizing, optimizing, and summarizing it to reach the targeted audience using our text analytics services.",
    },
    {
      src: "/assets/AdvancedAI/ComputerVision/image.png",
      alt: "Image Classification",
      width: "60%",
      paddingTop: "2%",
      text: "Image Classification",
      description:
        "Identify what the image represents. Categorize and label groups of pixels or vectors in a picture.",
    },
    {
      src: "/assets/AdvancedAI/ComputerVision/emotion.png",
      alt: "Real-Time Emotion Detection",
      width: "60%",
      paddingTop: "2%",
      text: "Real-Time Emotion<br />Detection",
      description:
        "Interpret facial landmarks and non-verbal indicators in pictures and videos to determine an individual’s emotional state.",
    },
    {
      src: "/assets/AdvancedAI/ComputerVision/cctv.png",
      alt: "Security Surveillance",
      width: "60%",
      paddingTop: "2%",
      text: "Security /<br />Surveillance",
      description:
        "Monitor security footage in real-time, spot patterns or suspicious behavior, regulate access to specific sites, and take pre-emptive action.",
    },
    {
      src: "/assets/AdvancedAI/ComputerVision/faceid.png",
      alt: "Face Recognition",
      width: "60%",
      paddingTop: "2%",
      text: "Face Recognition /<br />ID",
      description:
        "Provide real-time surveillance and tracking of people whose photographs have been saved in the data set. Mathematically map an individual’s facial traits.",
    },
    {
      src: "/assets/AdvancedAI/ComputerVision/run.png",
      alt: "Body Pose Detection",
      width: "60%",
      paddingTop: "2%",
      text: "Body Pose<br />Detection",
      description:
        "Identify, track, and detect the location of human body parts and joints to create a human body representation from the visual data.",
    },
    {
      src: "/assets/AdvancedAI/ComputerVision/ocr.png",
      alt: "Invoice Segmentation",
      width: "60%",
      paddingTop: "2%",
      text: "Invoice segmentation<br />& OCR Data<br />Extraction",
      description:
        "Convert receipts or images of invoices into machine-readable text data in the form of structured documents by extracting crucial information from them.",
    },
    {
      src: "/assets/AdvancedAI/ComputerVision/imagedup.png",
      alt: "Image Similarity & Deduplication",
      width: "60%",
      paddingTop: "2%",
      text: "Image Similarity & De-<br />duplication",
      description:
        "Detect and delete duplicate and near-duplicate photographs from your collection automatically while displaying the images to ensure the correct ones are removed.",
    },
  ];

  const offeringDataTransformed = [
    {
      src: "/assets/AdvancedAI/ComputerVision/tracking.png",
      alt: "Object Detection and Tracking",
      title: "Object detection &\nTracking",
      imgWidth: "60%",
      paddingTop: "2%",
      description:
        "With our 7+ years of experience, we assist your business by boosting material by categorizing, optimizing, and summarizing it to reach the targeted audience using our text analytics services.",
    },
    {
      src: "/assets/AdvancedAI/ComputerVision/image.png",
      alt: "Image Classification",
      title: "Image Classification",
      imgWidth: "60%",
      paddingTop: "2%",
      description:
        "Identify what the image represents. Categorize and label groups of pixels or vectors in a picture.",
    },
    {
      src: "/assets/AdvancedAI/ComputerVision/emotion.png",
      alt: "Real-Time Emotion Detection",
      title: "Real-Time Emotion\nDetection",
      imgWidth: "60%",
      paddingTop: "2%",
      description:
        "Interpret facial landmarks and non-verbal indicators in pictures and videos to determine an individual’s emotional state.",
    },
    {
      src: "/assets/AdvancedAI/ComputerVision/cctv.png",
      alt: "Security Surveillance",
      title: "Security / Surveillance",
      imgWidth: "60%",
      paddingTop: "2%",
      description:
        "Monitor security footage in real-time, spot patterns or suspicious behavior, regulate access to specific sites, and take pre-emptive action.",
    },
    {
      src: "/assets/AdvancedAI/ComputerVision/faceid.png",
      alt: "Face Recognition",
      title: "Face Recognition / ID",
      imgWidth: "60%",
      paddingTop: "2%",
      description:
        "Provide real-time surveillance and tracking of people whose photographs have been saved in the data set. Mathematically map an individual’s facial traits.",
    },
    {
      src: "/assets/AdvancedAI/ComputerVision/run.png",
      alt: "Body Pose Detection",
      title: "Body Pose\nDetection",
      imgWidth: "60%",
      paddingTop: "2%",
      description:
        "Identify, track, and detect the location of human body parts and joints to create a human body representation from the visual data.",
    },
    {
      src: "/assets/AdvancedAI/ComputerVision/ocr.png",
      alt: "Invoice Segmentation",
      title: "Invoice segmentation\n& OCR Data\nExtraction",
      imgWidth: "60%",
      paddingTop: "2%",
      description:
        "Convert receipts or images of invoices into machine-readable text data in the form of structured documents by extracting crucial information from them.",
    },
    {
      src: "/assets/AdvancedAI/ComputerVision/imagedup.png",
      alt: "Image Similarity & Deduplication",
      title: "Image Similarity & De-\nduplication",
      imgWidth: "60%",
      paddingTop: "2%",
      description:
        "Detect and delete duplicate and near-duplicate photographs from your collection automatically while displaying the images to ensure the correct ones are removed.",
    },
  ];
  
  

const AIComputerVision = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", overflowX: "hidden" }}>
      <PageIntro
        bg={"/assets/AdvancedAI/ComputerVision/background.webp"}
        subheading={"Giving machines a visual understanding of the world"}
        heading={"Computer Vision Development Services"}
        desc={
          "Our team of experts will help you to select the right platform, develop applications, integrate cameras, and improve process efficiency by embedding with other systems"
        }
      />

      <SplitDescription
        heading1={"Computer vision and AI – A perfect blend of innovation"}
        heading2={"Insights at your doorstep"}
        content1={`Image and video analytics have the potential to solve many social, political, economic, and industry issues. With advances in multi-lingual speech recognition, machine vision, and rules-based decision engines, it has become easier for enterprises to draw inferences using real-time streams of image and video content.​`}
        content2={`Enjoy visible operational functionality, 360-degree decision making, and performance analysis as we supply cost-effective services for natural language processing, text-to-speech, machine learning, knowledge virtualization, and more. If top machine learning companies in USA are what you’re looking for, then Tecloq is the right stop for you. Our AI and Machine Learning services blend business, development, and operations data to give actionable insights and give our clients a unified view of their changing business environments, allowing them to take advantage of the automation and resulting in better business outcomes over time.`}
        img1={"/assets/AdvancedAI/ComputerVision/innovation.png"}
        img2={"/assets/AdvancedAI/ComputerVision/doorstep.png"}
      />

      <Box
        sx={{
          maxWidth: "100% !important",
          height: "auto",
          marginTop: { xs: "5%", sm: "8%", md: "10%" },
        }}
      >
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "24px", sm: "32px", md: "40px" },
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: { xs: "5%", sm: "4%", md: "3%" },
            textAlign: "center",
          }}
        >
          Our Computer Vision Solutions Offerings
        </Typography>
      </Box>

      {/* <ServicesGridCards data={offeringdata}/> */}
      <GridCards data={offeringDataTransformed}  cardWidth={"300px"}/>



      {/* <Box sx={{display:"flex", flexDirection:"column", maxWidth:"100%", height:"auto", alignItems: "center"}}>
                    <Typography sx={{display:"flex", alignContent:"center", justifyContent:"center",
                        marginTop:"6%", fontFamily:"Orbitron !important", fontSize:"50px", fontWeight:"700",
                        letterSpacing:"2%", lineHeight:"120%"}}>
                        Technologies</Typography>
                    <img src='/assets/landingPage/modelImg.png' alt='tech' style=
                    {{width:"75%", height:"auto", paddingTop:"3%", paddingBottom:"5%"}}>
                    </img>
                </Box> */}

        <TransformComponent />
    </Box>
  );
};

export default AIComputerVision;
